import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./style.css";
import TSPaySessionExpired from "./sessionExpired";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import TSPayLogo from "../../../assets/img/logo-ts-pay-152px.png";
import numeral from "numeral";
import moment from "moment";
import { Button, Modal, RadioButton, Checkbox } from "@ts-digital/vrc";
import { Input, Tooltip } from "antd";
import LoaderSimple from "../../general/loader";
import { getBankLogo } from "../bank-logos";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { renewConsent } from "../../../store/actions/tspay";
import VaporFullscreenOverlay from "../../vapor/fullscreenOverlay";
import TSPayAddAccountView from "../../../views/tspay/addAccount";
import PartiesSearchInput from "../../parties/searchInput";
import { loadAccounts } from "../../../store/actions/tspay";
import { clearConsentsAccounts } from "../../../store/actions/tspay/consents";
import { getParties, editParty } from "../../../store/actions/parties/index";
import { DATE_FORMAT_FOR_DISPLAY } from "../../../constants/constants";
import TSPayPaymentWaitingModal from "./waitingModal";
import iban from "iban";
import { FEATURE_TOGGLE_ONLY_DEV } from "../../../config";
import { buildIbans } from "../../../libs/fakeGenerator/iban";
import { faDev } from "@fortawesome/free-brands-svg-icons";
import { displaySuccessToast } from "../../../store/actions/overflowNotification";
import { useContext } from "react";
import { RegistryContext } from "../../../contexts/RegistryContext";
import { VaporDatePicker } from "../../vapor";

const TsPayPaymentPage = props => {
  const {    
    selectedParty,
    setSelectedParty,
    deadlineSelected,
    selectedBankAccount,
    selectedBeneficiary,
    selectedDate,
    setSelectedBankAccount,
    setSelectedBeneficiary,
    setSelectedDate,
    itemsToPay,
    SCAManagerStatus,
    onPaymentButtonClick,
    setDeadlineSelected,
    paymentResponse,
    uuidToCheck,
    reason,
    setReason,
    totalAmount,
    setTotalAmount,
    fromDocuments,
    modifiedIban,
    setModifiedIban
  } = props;

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const main = useSelector(state => state.main);
  const tspay = useSelector(state => state.tspay);
  const parties = useSelector(state => state.parties?.getParties?.data?.results);

  const [disabledPay, setDisabledPay] = useState(true);
  const [newAccountDialog, setNewAccountDialog] = useState(false);
  const [accountsIdsAdded, setAccountsIdsAdded] = useState([]);
  const [childWindow, setChildWindow] = useState(null);
  const [modifyIbanDialog, setModifyIbanDialog] = useState(false);
  const [SCAManagerStatusRenew, setSCAManagerStatusRenew] = useState(null);
  const [isValidIban, setIsValidIban] = useState(null);
  const registryStore = useContext(RegistryContext);
  const mounted = useRef();

  let deadlinesList = [];
  let deadlinesToShow = [];
  if (location.state) {
    if (location.state.deadlines) {
      deadlinesList = location.state.deadlines;
      if (fromDocuments) {
        deadlinesList.map(itm => {
          deadlinesToShow.push({
            id: itm.id,
            toPay: itm.payment && itm.payment.step === "to_be_paid",
            date: moment(itm.date).format(DATE_FORMAT_FOR_DISPLAY),
            amount:
              itm.totalAmount > 0 ? (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <FontAwesomeIcon
                    icon={["fas", "plus-circle"]}
                    style={{ fontSize: 12, color: "#0d6d80", marginRight: 8 }}
                  />
                  {itm.totalAmount
                    ? new Intl.NumberFormat("it-IT", {
                      style: "decimal",
                      currency: "EUR",
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    }).format(Math.abs(parseFloat(itm.totalAmount))) + " €"
                    : "0 €"}
                </div>
              ) : (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <FontAwesomeIcon
                    icon={["fas", "minus-circle"]}
                    style={{ fontSize: 12, color: "#c53090", marginRight: 8 }}
                  />
                  {itm.totalAmount
                    ? new Intl.NumberFormat("it-IT", {
                      style: "decimal",
                      currency: "EUR",
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    }).format(Math.abs(parseFloat(itm.totalAmount))) + " €"
                    : "0 €"}
                </div>
              ),
            arrow: (
              <div
                onClick={e => goToDeadline(itm.id)}
                style={{
                  color: "#0090d1",
                  cursor: "pointer"
                }}
              >
                <FontAwesomeIcon
                  icon={["far", "arrow-right"]}
                  style={{ marginRight: 8 }}
                />
              </div>
            )
          });
          return null;
        });
      }
    }
  }

  useEffect(() => {
    dispatch(clearConsentsAccounts());
  }, []);

  useEffect(() => {
    dispatch(loadAccounts(
      auth, main.accountantUuidSelected, main.companyUuidSelected
    ));
  }, []);

  useEffect(() => {
    let listIds = [];
    let accountsAdded = [];
    if (tspay.consents && tspay.consents.accounts !== []) {
      accountsAdded = tspay.consents.accounts;
      accountsAdded.map(account => {
        return listIds.push(account.accountId);
      });
      setAccountsIdsAdded(listIds);
    }
  }, [tspay.consents.accounts]);

  useEffect(() => {
    let disabled = true;
    if (
      selectedDate &&
      selectedBankAccount &&
      selectedBankAccount.iban &&
      selectedBeneficiary &&
      (selectedBeneficiary.iban || modifiedIban) &&
      selectedBeneficiary.name &&
      ((fromDocuments && deadlineSelected.length > 0) ||
        (fromDocuments && itemsToPay.length === 1) ||
        !fromDocuments)
    ) {
      disabled = false;
    }
    setDisabledPay(disabled);
  }, [
    selectedDate,
    selectedBankAccount,
    selectedBeneficiary,
    deadlineSelected,
    modifiedIban
  ]);

  useEffect(() => {
    if (SCAManagerStatus === "paying") {
      setChildWindow(window.open(paymentResponse.scaManagerRedirectUrl));
    }
  }, [SCAManagerStatus]);

  useEffect(() => {
    if (SCAManagerStatusRenew) {
      let childWindowR = window.open(SCAManagerStatusRenew);
      let timer = setInterval(function() {
        if (childWindowR.closed) {
          clearInterval(timer);
          setSCAManagerStatusRenew(null);
        }
      }, 1000);
    } else {
      dispatch(loadAccounts(
        auth,
        main.accountantUuidSelected,
        main.companyUuidSelected
      ));
    }
  }, [SCAManagerStatusRenew]);

  useEffect(() => {
    if (!newAccountDialog) {
      dispatch(loadAccounts(
        auth,
        main.accountantUuidSelected,
        main.companyUuidSelected
      ));
    }
  }, [newAccountDialog]);

  useEffect(() => {
    if (fromDocuments) {
      if (itemsToPay.length === 1 && deadlineSelected.length === 0) {
        setDeadlineSelected([itemsToPay[0].id]);
      }
    }
  });

  useEffect(() => {
    if (fromDocuments) {
      if (itemsToPay.length === 1) {
        setTotalAmount(itemsToPay[0].totalAmount);
      }
    }
  });

  useEffect(() => {
    if (fromDocuments) {
      let amount = 0;
      deadlinesList.map(deadline => {
        if (deadlineSelected.indexOf(deadline.id) > -1) {
          amount += deadline.totalAmount;
        }
        return null;
      });
      if (amount < 0) {
        amount = amount * -1;
      }
      setTotalAmount(amount);
    }
  }, [deadlineSelected]);

  useEffect(() => {
    if (modifiedIban !== "" && modifiedIban !== undefined) {
      setIsValidIban(iban.isValid(modifiedIban));
    } else {
      setIsValidIban(null);
    }
  }, [modifiedIban]);

  useEffect(() => {
    if (!mounted.current) {
      // set mounted to true
      mounted.current = true;
    } else {
      // do componentDidUpdate logic
      const lastAddedContact = parties?.[parties?.length - 1];
      setSelectedBeneficiary({
        id: lastAddedContact?.id,
        name: lastAddedContact?.description,
        iban: lastAddedContact?.iban
          ? lastAddedContact?.iban
          : lastAddedContact?.bankAccounts && lastAddedContact?.bankAccounts[0]
            ? lastAddedContact?.bankAccounts[0].iban
            : undefined
      });
    }
  }, [registryStore.isLastContactAdded]);

  const goToDeadline = deadlineId => {
    navigate("/scadenza/" + deadlineId);
  };

  const onSetDeadlinesIdList = (deadlineId, checked) => {
    let cloneList = [...deadlineSelected];
    if (checked) {
      cloneList.push(deadlineId);
    } else {
      cloneList.splice(cloneList.indexOf(deadlineId), 1);
    }
    setDeadlineSelected(cloneList);
  };

  const renderListItem = () => {
    let rowList = [];
    for (let i = 0, ci = deadlinesToShow.length; i < ci; ++i) {
      const element = deadlinesToShow[i];
      rowList.push(<div
        className={"dbx-tspay-deadlines-select"}
        key={"dbx-tspay-deadlines-select_" + element.id}
      >
        <div style={{ display: "flex" }}>
          <div style={{ width: "10%" }}>
            <Tooltip
              color={"rgb(0, 80, 117)"}
              title={!element.toPay ? "Scadenza già pagata" : ""}>
              <Checkbox
                disabled={!element.toPay}
                checked={deadlineSelected.indexOf(element.id) > -1}
                onChange={checked =>
                  onSetDeadlinesIdList(element.id, checked)
                }
              ></Checkbox>
            </Tooltip>
          </div>
          <div className="align-center" style={{ width: "15%" }}>
            <FontAwesomeIcon icon={["far", "alarm-clock"]} />
          </div>
          <div style={{ width: "35%" }}>{element.date}</div>
          <div style={{ width: "35%" }}>{element.amount}</div>
          <div className="align-center" style={{ width: "10%" }}>
            {element.arrow}
          </div>
        </div>
      </div>);
    }
    return rowList;
  };

  const onRenewClick = account => {
    dispatch(renewConsent(
      auth, main.companyUuidSelected, account.consentId
    )).then(result => {
      setSCAManagerStatusRenew(result.scaManagerRedirectUrl);
    });
  };

  const goBack = () => {
    navigate(location.state.backTo);
  };

  const getLogo = account => {
    let logo;
    if (account && account.logoUrl) {
      const logoImg = getBankLogo(account.logoUrl);
      if (logoImg) {
        logo = <img src={logoImg} alt="" />;
      }
    }
    return logo;
  };

  const renderBankAccounts = () => {
    let items = [];
    tspay.accounts.list.map(account => {
      let isValid = new Date() <= new Date(account.consentExpireDate);
      let isNew = accountsIdsAdded.includes(account.id);
      return items.push(<Tooltip
        overlayClassName={isValid ? "" : "BankAccounts-tooltip"}
        title={
          !isValid ? (
            <div
              onClick={() => {
                onRenewClick(account);
              }}
              style={{ cursor: "pointer" }}
            >
              Rinnova il consenso al collegamento del conto
            </div>
          ) : account.amount < 0 ? (
            "La disponibilità potrebbe non essere sufficiente per il pagamento"
          ) : (
            ""
          )
        }
      >
        <div
          className={
            "dbx-tspay-payment-bank-accounts-card" +
            (isNew
              ? " animation"
              : !isValid
                ? " disabled"
                : account.amount < 0
                  ? " insufficient"
                  : "")
          }
        // style = {{backgroundColor: !isNew ? "var(--text-04)" : null}}
        >
          <div className="dbx-tspay-payment-bank-accounts-card-left">
            <div className="dbx-tspay-payment-bank-accounts-card-selected">
              <RadioButton
                disabled={!isValid || SCAManagerStatus === "paying"}
                checked={
                  selectedBankAccount &&
                  account.iban === selectedBankAccount.iban
                }
                onChange={() => setSelectedBankAccount(account)}
              />
            </div>
            <div
              className="dbx-tspay-payment-bank-accounts-card-logo"
              style={{
                backgroundImage: `url(${getLogo(account).props.src})`
              }}
            ></div>
            <div className="dbx-tspay-payment-bank-accounts-card-description">
              <div>{account.bankName}</div>
              <div>{account.iban}</div>
            </div>
          </div>
          <div className="dbx-tspay-payment-bank-accounts-card-right">
            {isValid ? (
              <div className="dbx-tspay-payment-bank-accounts-card-amount">
                <div>{numeral(account.amount).format("0,0.00")} €</div>{" "}
                <div>Saldo disponibile</div>
              </div>
            ) : (
              <div className="dbx-tspay-payment-bank-accounts-card-amount">
                <div>{" - "}</div>
                <div>Consenso scaduto</div>
              </div>
            )}
          </div>
        </div>
      </Tooltip>);
    });

    items.push(<div
      onClick={() => {
        setNewAccountDialog(true);
      }}
      className="dbx-tspay-payment-bank-accounts-card new-bank-account"
    >
      <FontAwesomeIcon icon={["far", "plus"]} /> Aggiungi un conto
    </div>);

    return <div className="dbx-tspay-payment-bank-accounts-list">{items}</div>;
  };

  const checkAndOpenIbanUpdateDialog = () => {
    if (
      modifiedIban !== "" &&
      modifiedIban !== undefined &&
      modifiedIban !== selectedBeneficiary.iban &&
      selectedBeneficiary.id &&
      selectedBeneficiary.from !== "xml"
    ) {
      setModifyIbanDialog(true);
      setSelectedParty({
        ...selectedParty,
        bankAccounts: [
          {
            ...selectedParty.bankAccounts[0],
            iban: modifiedIban
          }
        ]
      });
    }
  };

  const renderBody = () => {
    const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", "DD-MM-YY", "DDMMYYYY", "DDMMYY"];
    return (
      <React.Fragment>
        <div className="dbx-tspay-payment-box-title">
          <FormattedMessage id="tspay.payment.mainbox.title" />
        </div>
        <div className="dbx-tspay-payment-box-content">
          <div className="dbx-tspay-payment-box-date">
            <div className="dbx-tspay-payment-date-description-container">
              <div
                className="dbx-tspay-payment-date-description-field"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <div style={{ marginBottom: 16 }}>Data pagamento *</div>
                <div>
                  <VaporDatePicker
                    format={dateFormatList}
                    getPopupContainer={(trigger) => trigger.parentNode}
                    disabled={SCAManagerStatus === "paying"}
                    value={selectedDate}
                    onChange={e => setSelectedDate(e)}
                    style={{ width: 200 }}
                  />
                </div>
              </div>
              <div
                className="dbx-tspay-payment-date-description-field"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <div style={{ marginBottom: 16 }}>Causale *</div>
                <div>
                  <Input.TextArea
                    showCount
                    maxLength={140}
                    rows={2}
                    value={reason}
                    onChange={e => setReason(e.target.value)}
                    className="dbx-tspay-payment-description-input"
                    placeholder="Inserisci causale"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="dbx-tspay-payment-box-beneficiary">
            <div
              className="dbx-tspay-payment-box-beneficiary-title"
              style={{ display: "flex", width: "453px" }}
            >
              <div style={{ color: "#005075" }}>BENEFICIARIO</div>
              {/* <div>
                {<FontAwesomeIcon icon={["far", "book-open"]} /> }
                Rubrica
              </div> */}
            </div>

            {tspay.payment.isGettingIbanSuggestion ? (
              <div className="dbx-tspay-payment-box-beneficiary-fields">
                <LoaderSimple />
              </div>
            ) : (
              <div className="dbx-tspay-payment-box-beneficiary-fields">
                <div>
                  <div style={{ marginBottom: 16 }}>
                    Nome e cognome, o ragione sociale *
                  </div>
                  <PartiesSearchInput
                    registryStore={registryStore}                    
                    disabled={SCAManagerStatus === "paying"}
                    selected={
                      selectedBeneficiary
                        ? {
                          id: selectedBeneficiary.id,
                          description: selectedBeneficiary.name
                        }
                        : undefined
                    }
                    onSelect={party => {
                      if (!party.description) return;
                      setModifiedIban(undefined);
                      setSelectedParty(party);
                      setSelectedBeneficiary({
                        id: party.id,
                        name: party.description,
                        iban: party.iban
                          ? party.iban
                          : party.bankAccounts && party.bankAccounts[0]
                            ? party.bankAccounts[0].iban
                            : undefined
                      });
                    }}
                    onClear={() => {
                      setSelectedBeneficiary({
                        id: undefined,
                        name: undefined,
                        iban: undefined
                      });
                    }}
                    value={selectedBeneficiary.name}
                    placeholder="Seleziona il beneficiario"
                  />
                  <div className="dbx-tspay-payment-box-beneficiary-tip">
                    {selectedBeneficiary.from === "xml" &&
                      "Dati beneficiario caricati automaticamente da fattura"}
                    {selectedBeneficiary.from === "parties" &&
                      "Dati beneficiario caricati automaticamente da rubrica"}
                    &nbsp;
                  </div>
                </div>
                <div>
                  <div style={{ marginBottom: 16 }}>
                    IBAN *
                    {isValidIban && (
                      <FontAwesomeIcon
                        icon={["far", "check"]}
                        style={{
                          marginLeft: 10,
                          fontSize: 16,
                          color: "#09822a"
                        }}
                      />
                    )}
                  </div>
                  <Input
                    style={{
                      border: isValidIban === false ? "1px solid red" : ""
                    }}
                    disabled={SCAManagerStatus === "paying"}
                    value={
                      modifiedIban !== undefined
                        ? modifiedIban
                        : selectedBeneficiary
                          ? selectedBeneficiary.iban
                          : undefined
                    }
                    onBlur={() => {
                      checkAndOpenIbanUpdateDialog();
                    }}
                    onKeyPress={e => {
                      if (e.key === "Enter") {
                        checkAndOpenIbanUpdateDialog();
                      }
                    }}
                    onChange={e => {
                      setModifiedIban(e.target.value.toUpperCase());
                      /* setSelectedBeneficiary({
                        ...selectedBeneficiary,
                        iban: e.target.value.toUpperCase()
                      });*/
                    }}
                    suffix={
                      FEATURE_TOGGLE_ONLY_DEV === "true" ? (
                        <Tooltip 
                          color={"rgb(0, 80, 117)"}
                          title="[DEV] generate iban">
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              let tmpIban = buildIbans("Italy");
                              setModifiedIban(tmpIban);
                            }}
                          >
                            <FontAwesomeIcon icon={faDev} />
                          </div>
                        </Tooltip>
                      ) : null
                    }
                  />
                  <div className="dbx-tspay-payment-box-beneficiary-tip">
                    &nbsp;
                  </div>
                </div>
              </div>
            )}
            <div className="dbx-tspay-payment-box-bank-account">
              <div>
                <div style={{ marginBottom: 16 }}>Seleziona conto *</div>
                {!tspay.accounts.status.started &&
                  !tspay.consents.isRequestingConsentRenew ? (
                    renderBankAccounts()
                  ) : tspay.consents.isRequestingConsentRenew ? (
                    <LoaderSimple message="Richiesta rinnovo del consenso in corso..." />
                  ) : (
                    <LoaderSimple message="Caricamento conti correnti..." />
                  )}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  const renderItemsToPay = () => {
    let retVal;
    if (itemsToPay && itemsToPay.length === 1) {
      retVal = itemsToPay[0].description
        ? itemsToPay[0].description.title +
        (itemsToPay[0].description.details &&
          itemsToPay[0].description.details !== ""
          ? ` - ${itemsToPay[0].description.details}`
          : "")
        : "";
    } else if (itemsToPay && itemsToPay.length > 1) {
      retVal = [];
      itemsToPay.map(it => {
        if (it.description && it.description.title) {
          retVal.push(<div>
            {it.description.title} {it.description.details}
          </div>);
        }
        return null;
      });
    }
    return retVal;
  };

  const renderModifyIbanModal = () => {
    return (
      <Modal
        title={"Nuovo IBAN"}
        visible={modifyIbanDialog}
        onClose={() => {
          setModifyIbanDialog(false);
        }}
        type="primary"
        footer={
          <div
            style={{
              height: 56,
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              width: "100%",
              gap: 10
            }}
          >
            <Button
              kind="secondary"
              onClick={() => setModifyIbanDialog(false)}
              size="medium"
            >
              <FormattedMessage id="actions.cancel" />
            </Button>
            <Button
              size="medium"
              onClick={() => {
                dispatch(editParty(
                  auth,
                  main.companyUuidSelected,
                  selectedParty.id,
                  selectedParty.version,
                  { iban: modifiedIban }
                )).then(res => {
                  dispatch(getParties(
                    auth, main.companyUuidSelected, 50, "asc"
                  ));
                  setSelectedBeneficiary({
                    ...selectedBeneficiary,
                    iban: modifiedIban
                  });
                  setModifiedIban(undefined);
                  dispatch(displaySuccessToast("Iban modificato con successo"));
                });
                setModifyIbanDialog(false);
              }}
            >
              Aggiorna
            </Button>
          </div>
        }
      >
        <div
          style={{ width: 488, fontSize: 16, marginTop: 20, marginBottom: 40 }}
        >
          Questo IBAN non corrisponde a quello del beneficiario salvato in
          rubrica. Desideri modificare il contatto aggiornando l'IBAN?
        </div>
      </Modal>
    );
  };

  return (
    <div
      className={
        "dbx-tspay-payment-root" +
        (SCAManagerStatus === "waiting" ? " isWaitingSCA" : "")
      }
    >
      {newAccountDialog && (
        <VaporFullscreenOverlay
          title="AGGIUNGI UN CONTO"
          subtitle="Collega un conto corrente al servizio TS Pay"
          width={"95vw"}
          onClose={() => {
            setNewAccountDialog(false);
            if (window.aptrinsic) {
              window.aptrinsic("track", "digital-box:TSPAY-AGGIUNGICONTO");
            }
          }}
        >
          <TSPayAddAccountView
            isFullscreenOverlay={true}            
            onClose={() => {
              setNewAccountDialog(false);
            }}
          />
        </VaporFullscreenOverlay>
      )}
      {modifyIbanDialog && renderModifyIbanModal()}
      {SCAManagerStatus !== "done" && (
        <div className="dbx-tspay-payment-header">
          <div className="dbx-tspay-payment-header-left">
            {location.state && location.state.deadlines && (
              <div
                style={{ cursor: "pointer" }}
                onClick={() => {
                  if (location.state.documentId) {
                    navigate("/dettaglio-documento/" +
                      location.state.documentId);
                  } else if (location.state.deadlines.length > 1) {
                    navigate("/scadenze");
                  } else {
                    navigate("/scadenza/" + location.state.deadlines[0].id);
                  }
                }}
              >
                <FontAwesomeIcon icon={["far", "arrow-left"]} />{" "}
                {<FormattedMessage id="generic.back" />}
              </div>
            )}
          </div>
          <div className="dbx-tspay-payment-header-center">
            <img src={TSPayLogo} alt="logo_tspay" />
          </div>
          <div className="dbx-tspay-payment-header-right"></div>
        </div>
      )}
      <div className="dbx-tspay-payment-container">
        <div
          className={
            "dbx-tspay-payment-body" +
            (itemsToPay ? "" : " fullWidth") +
            " " +
            SCAManagerStatus
          }
        >
          {SCAManagerStatus === "paying" && (
            <TSPayPaymentWaitingModal
              uuidToCheck={uuidToCheck}              
              childWindow={childWindow}
              selectedBankAccount={selectedBankAccount}
              paymentResponse={paymentResponse}
              getLogo={getLogo}
            />
          )}
          {SCAManagerStatus === "done" && (
            <div className="dbx-tspay-payment-done">
              <div className="dbx-tspay-payment-done-logo">
                <img src={TSPayLogo} alt="logo_tspay" />
              </div>
              <div className="dbx-tspay-payment-done-text">
                La richiesta è andata a buon fine!
                <br />
                Controlla lo stato del pagamento nel dettaglio{" "}
                {fromDocuments ? "del documento" : "della scadenza"}.
              </div>
              <div className="dbx-tspay-payment-done-button">
                <Button
                  onClick={() => {
                    if (fromDocuments) {
                      navigate("/dettaglio-documento/" +
                        location.state.documentId);
                    } else {
                      if (location.state.deadlines.length > 1) {
                        navigate("/scadenze");
                      } else {
                        navigate("/scadenza/" + location.state.deadlines[0].id);
                      }
                    }
                  }}
                >
                  {fromDocuments
                    ? "Torna al documento"
                    : location.state.deadlines.length > 1
                      ? "Torna alle scadenze"
                      : "Torna alla scadenza"}
                </Button>
              </div>
            </div>
          )}
          {SCAManagerStatus !== "done" &&
            SCAManagerStatus !== "paying" &&
            !itemsToPay && <TSPaySessionExpired />}
          {SCAManagerStatus !== "done" && itemsToPay && renderBody()}
        </div>
        {SCAManagerStatus !== "done" && itemsToPay && (
          <div className="dbx-tspay-payment-sidebox">
            <div className="dbx-tspay-payment-box-title">
              <FormattedMessage id="tspay.payment.sidebox.title" />
            </div>
            <div className="dbx-tspay-payment-box-content">
              <div className="dbx-tspay-payment-summary-deadline">
                <div className="dbx-tspay-payment-summary-tip">
                  <FormattedMessage
                    id={
                      itemsToPay.length < 2
                        ? "tspay.payment.sidebox.summaryTipSingle"
                        : "tspay.payment.sidebox.summaryTipMultiple"
                    }
                  />
                </div>
                <div className="dbx-tspay-payment-summary-description">
                  {renderItemsToPay()}
                </div>
              </div>
              {reason && reason !== "" && (
                <div
                  className="dbx-tspay-payment-summary-reason"
                  style={{ marginTop: 16 }}
                >
                  <div className="dbx-tspay-payment-summary-tip">
                    <FormattedMessage
                      id={"tspay.payment.sidebox.summaryTipReason"}
                    />
                  </div>
                  <div className="dbx-tspay-payment-summary-description">
                    {reason}
                  </div>
                </div>
              )}
              {selectedBeneficiary &&
                selectedBeneficiary.name &&
                selectedBeneficiary.name !== "" && (
                <div
                  className="dbx-tspay-payment-summary-beneficiary"
                  style={{ marginTop: 16 }}
                >
                  <div className="dbx-tspay-payment-summary-tip">
                    <FormattedMessage
                      id={"tspay.payment.sidebox.summaryTipBeneficiary"}
                    />
                  </div>
                  <div className="dbx-tspay-payment-summary-description">
                    {selectedBeneficiary.name}
                    {selectedBeneficiary.iban &&
                        selectedBeneficiary.iban !== "" && (
                      <React.Fragment>
                        <br />
                        <span style={{ fontWeight: 400 }}>
                          <FormattedMessage
                            id={
                              "tspay.payment.sidebox.summaryTipBeneficiaryIban"
                            }
                          />
                        </span>{" "}
                        {modifiedIban && modifiedIban !== ""
                          ? modifiedIban
                          : selectedBeneficiary.iban}
                      </React.Fragment>
                    )}
                  </div>
                </div>
              )}
              {selectedDate && (
                <div
                  className="dbx-tspay-payment-summary-date"
                  style={{ marginTop: 16 }}
                >
                  <div className="dbx-tspay-payment-summary-tip">
                    <FormattedMessage
                      id={"tspay.payment.sidebox.summaryTipDate"}
                    />
                  </div>
                  <div className="dbx-tspay-payment-summary-description">
                    {selectedDate && (
                      <React.Fragment>
                        {selectedDate.format("DD/MM/YYYY")}
                      </React.Fragment>
                    )}
                  </div>
                </div>
              )}
              {itemsToPay.length > 1 ? (
                <div>
                  <div className="dbx-tspay-payment-list-deadline">
                    La fattura comprende {itemsToPay.length} scadenze per un
                    totale di{" "}
                    <b>
                      {totalAmount < 0
                        ? numeral(-1.0 * totalAmount).format("0,0", Math.floor)
                        : numeral(totalAmount).format("0,0", Math.floor)}
                      <span>
                        {totalAmount < 0
                          ? numeral(-1.0 * totalAmount).format(".00")
                          : numeral(totalAmount).format(".00")}
                        {" €"}
                      </span>
                    </b>
                    <br></br>Seleziona le scadenze da pagare
                  </div>
                  <div>{renderListItem()}</div>
                </div>
              ) : null}
              <div className="dbx-tspay-payment-summary-amount-logo">
                <div className="dbx-tspay-payment-summary-amount">
                  <div className="dbx-tspay-payment-summary-amount-label">
                    <FormattedMessage id="tspay.payment.sidebox.summaryAmount" />
                  </div>
                  <div className="dbx-tspay-payment-summary-amount-value">
                    {totalAmount < 0
                      ? numeral(-1.0 * totalAmount).format("0,0", Math.floor)
                      : numeral(totalAmount).format("0,0", Math.floor)}
                    <span>
                      {totalAmount < 0
                        ? numeral(-1.0 * totalAmount).format(".00")
                        : numeral(totalAmount).format(".00")}
                      {" €"}
                    </span>
                  </div>
                </div>
                <div className="dbx-tspay-payment-summary-logo">
                  {selectedBankAccount &&
                    selectedBankAccount.logoUrl &&
                    getLogo(selectedBankAccount)}
                </div>
              </div>
              <div className="dbx-tspay-payment-summary-footer">
                {SCAManagerStatus !== null ? (
                  SCAManagerStatus === "waiting" ? (
                    <LoaderSimple />
                  ) : null
                ) : SCAManagerStatus !== "paying" ? (
                  <React.Fragment>
                    <Button kind="secondary" onClick={() => goBack()}>
                      <FormattedMessage id="actions.cancel" />
                    </Button>
                    <Button
                      kind="primary"
                      onClick={onPaymentButtonClick}
                      disabled={disabledPay}
                    >
                      <FormattedMessage id="actions.pay" />
                    </Button>
                  </React.Fragment>
                ) : null}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TsPayPaymentPage;
